module.exports = __webpack_public_path__ + "bcd30d87641a321f9cfa51e4137ec04a.pdf";